import React from 'react';
import { createStore } from 'redux';
import { Provider, connect } from 'react-redux';
import Navbar from './Navbar';
import Footer from './Footer';
import TopBar from './TopBar';

// Fake Folder & File Data
const folderList = [
  {
    id: 1,
    name: 'Publications',
    type: 'user',
    files: [
      {
        name: 'QUICKBOOKS DESKTOP TRAINING MODULES',
        url: '../assets/QUICKBOOKS DESKTOP & ONLINE  TRAINING MODULES (1).pdf',
      },
    ],
  },
  { id: 2, name: 'Policies', type: 'admin', files: [] },
  { id: 3, name: 'Learning materials', type: 'shared', files: [] },
];

// Redux Setup
const initialState = {
  folders: folderList,
  selectedFolder: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SELECT_FOLDER':
      return {
        ...state,
        selectedFolder: action.payload,
      };
    default:
      return state;
  }
};

const store = createStore(reducer);

// Folder List (Left Panel)
class FolderList extends React.Component {
  handleClick = folder => {
    this.props.selectFolder(folder);
  };

  render() {
    const { folders, selectedFolder } = this.props;
    return (
      <div className="publication-sidebar">
          <h3 className="publication-heading">Publication Type</h3>
          <ul className="publication-folder-list">
            {folders.map(folder => (
              <li
                key={folder.id}
                onClick={() => this.handleClick(folder)}
                className={`publication-folder-item ${selectedFolder?.id === folder.id ? 'active' : ''}`}
              >
                📁 {folder.name}
              </li>
            ))}
          </ul>
      </div>
    );
  }
}

const mapFolderState = state => ({
  folders: state.folders,
  selectedFolder: state.selectedFolder,
});

const mapFolderDispatch = dispatch => ({
  selectFolder: folder => dispatch({ type: 'SELECT_FOLDER', payload: folder }),
});

const ConnectedFolderList = connect(mapFolderState, mapFolderDispatch)(FolderList);

// File List (Right Panel)
const FileList = ({ selectedFolder }) => (
  <div className="publication-content">
    <h3 className="publication-heading">{selectedFolder ? `${selectedFolder.name}` : 'List of publications'}</h3>
    {selectedFolder ? (
      <ul className="publication-file-list">
        {selectedFolder.files.map((file, idx) => (
          <li key={idx} className="publication-file-item">
            📄{' '}
            <a href={file.url} target="_blank" rel="noopener noreferrer" className="publication-file-link">
              {file.name}
            </a>
          </li>
        ))}
      </ul>
    ) : (
      <p className="publication-placeholder">Select publication type</p>
    )}
  </div>
);

const mapFileState = state => ({
  selectedFolder: state.selectedFolder,
});

const ConnectedFileList = connect(mapFileState)(FileList);

// Main File Explorer Layout
class FileExplorerContainer extends React.Component {
  render() {
    return (
      <>
        <TopBar />
        <main className="page-publication">
          <div className="container">
            <Navbar />
            <section className="page-header">
              <h1>Publications</h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb foi-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Publications
                  </li>
                </ol>
              </nav>
            </section>
          </div>
          <div className="container publication-shell">
            <div className="publication-workspace">
            <ConnectedFolderList />
            <ConnectedFileList />
            </div>
          </div>
        </main>
        <Footer />
      </>
    );
  }
}

// ✅ Exported Component
export default class Publication extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <FileExplorerContainer />
      </Provider>
    );
  }
}
